<template>
  <div>
    <v-navigation-drawer
      v-model="modal"
      class="cd_modal"
      absolute
      temporary
      right
      ref="drawerModal"
      :width="navigation.width"
    >
      {{/** MODAL CLOSE BTN **/}}
      <v-btn
        class="modal__close-btn"
        icon
        small
        absolute
        top
        left
        @click="modal = false"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
      {{/** END MODAL CLOSE BTN **/}}

      {{/** MODAL MENU **/}}
      <v-menu
        v-if="!modal_create_mode"
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            icon
            absolute
            small
            top
            right
            v-bind="attrs"
            v-on="on"
            class="modal__menu-btn"
          >
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-if="canSave"
            link
            @click="$emit('deleteItemDrawer')"
            style="display:flex; align-items:center;"
          >
            <v-icon size="14" class="mr-2 mb-1">$icondelete</v-icon>
            <v-list-item-title class="text-body-2" v-text="i18n.t('modules.customdata.entity.delete')" />
          </v-list-item>
        </v-list>
      </v-menu>
      {{/** END MODAL MENU **/}}

      <v-form ref="form" v-model="form_valid" class="settings-form">
        <v-card elevation="0">

          <v-card-title class="navigation-drawer__title">
            <template v-if="modal_create_mode">{{i18n.t('modules.customdata.entity.modal_title_create')}}</template>
            <template v-else>{{i18n.t('modules.customdata.entity.modal_title')}}</template>
          </v-card-title>

          <v-card-text v-if="modal">

            <template v-for="(field, key) in get_custom_data_front_json.modal_entity">

              <v-layout
                v-if="checkKeyNotExists(key, field)"
                :key="key"
                class="mb-4"
              >

                <v-icon
                  v-if="
                    field.icon &&
                    !['expansion-panels-variable'].includes(key)
                  "
                  :color="field.icon_color"
                  class="mr-2"
                >{{field.icon}}</v-icon>

                <!--STRING FIELDS-->
                <template v-if="['STRING'].includes(field.type)">
                  <template v-if="field.editable">
                    <template v-if="entity_fields?.[key]?.string_input">
                      <template
                        v-if="entity_fields[key].string_input.type === 'date'"
                      >
                        <date-picker
                          v-model.trim="item_obj[key]"
                          @input="emitItemEditObj(key, $event)"
                          :type="entity_fields[key].string_input.type"
                          :valueType="entity_fields[key].string_input.format"
                          :format="entity_fields[key].string_input.format"
                          :show-second="false"
                          :lang="$i18n.locale"
                          :editable="!canSave"
                          :append-to-body="false"

                          :disabled="checkDisableValidations(entity_fields[key], key)"
                          :disabled-date="(item) => checkDateValidations(item, entity_fields[key])"
                          :disabled-calendar-changer="(item) => checkDateValidations(item, entity_fields[key])"
                          :disabled-time="(item) => checkTimeValidations(item, entity_fields[key])"
                          :clearable="checkClearableValidations(entity_fields[key])"
                        />
                      </template>

                      <template
                        v-if="entity_fields[key].string_input.type === 'time'"
                      >
                        <div class="d-flex align-center">
                          <v-sheet width="210">
                            <TimeInput
                              v-model.trim="item_obj[key]"
                              @input="emitItemEditObj(key, $event)"
                              :label="returnFilterKeyOrLabel(key, field)"
                              :hide-details="'auto'"

                              :field_key="key"
                              :item_obj="item_obj"
                              :entity_fields="entity_fields"
                            />
                          </v-sheet>
                          <span
                            v-if="entity_fields[key].hint"
                            class="ml-2 text-caption grey--text text--darken-1"
                          >{{ entity_fields[key].hint }}</span>
                        </div>
                      </template>


                    </template>

                    <v-text-field
                      v-else
                      outlined
                      dense
                      v-model.trim="item_obj[key]"
                      @input="emitItemEditObj(key, $event)"
                      :label="returnFilterKeyOrLabel(key, field)"
                      :rules="field.rules"
                      :readonly="!modal_create_mode && !canSave"
                      hide-details="auto"
                    ></v-text-field>
                  </template>

                  <div v-else>
                    <span class="font-weight-bold mr-2">{{returnFilterKeyOrLabel(key, field)}}:</span>
                    <PrivacyFieldValue
                      v-if="isModalEntityPrivacyEnabled(field)"
                      :value="formatModalEntityDisplayValue(item_obj[key])"
                    />
                    <span v-else>{{ formatModalEntityDisplayValue(item_obj[key]) }}</span>
                  </div>
                </template>

                <!--TEXTAREA FIELDS-->
                <template v-if="['TEXT'].includes(field.type)">
                  <v-textarea
                    v-if="field.editable"
                    outlined
                    dense
                    v-model.trim="item_obj[key]"
                    @input="emitItemEditObj(key, $event)"
                    :label="returnFilterKeyOrLabel(key, field)"
                    :rules="field.rules"
                    auto-grow
                    rows="2"
                    :readonly="!modal_create_mode && !canSave"
                    hide-details="auto"
                  ></v-textarea>
                  <div v-else>
                    <span class="font-weight-bold mr-2">{{returnFilterKeyOrLabel(key, field)}}:</span>
                    <PrivacyFieldValue
                      v-if="isModalEntityPrivacyEnabled(field)"
                      :value="formatModalEntityDisplayValue(item_obj[key])"
                    />
                    <span v-else>{{ formatModalEntityDisplayValue(item_obj[key]) }}</span>
                  </div>
                </template>

                <!-- INTEGER FIELDS -->
                <template v-if="['INTEGER', 'BIGINT'].includes(field.type)">
                  <v-text-field
                    v-if="field.editable"
                    outlined
                    dense
                    v-model.trim="item_obj[key]"
                    @input="emitItemEditObj(key, $event)"
                    :label="returnFilterKeyOrLabel(key, field)"
                    :rules="[rules.onlyDigits]"
                    :readonly="!modal_create_mode && !canSave"
                    hide-details="auto"
                  ></v-text-field>
                  <div v-else>
                    <span class="font-weight-bold mr-2">{{returnFilterKeyOrLabel(key, field)}}:</span>
                    <PrivacyFieldValue
                      v-if="isModalEntityPrivacyEnabled(field)"
                      :value="formatModalEntityDisplayValue(item_obj[key])"
                    />
                    <span v-else>{{ formatModalEntityDisplayValue(item_obj[key]) }}</span>
                  </div>
                </template>

                <!-- BOOL FIELDS -->
                <template v-if="['BOOLEAN'].includes(field.type)">
                  <v-checkbox
                    v-if="field.editable"
                    v-model="item_obj[key]"
                    @input="emitItemEditObj(key, $event)"
                    :label="returnFilterKeyOrLabel(key, field)"
                    hide-details="auto"
                    :rules="field.rules"
                    class="mt-0 mb-4"
                    :readonly="!modal_create_mode && !canSave"
                  ></v-checkbox>
                </template>

                <!-- DATE FIELDS -->
                <v-menu
                  v-else-if="['DATE'].includes(field.type)"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  :disabled="!modal_create_mode && !canSave"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      dense
                      :value="formatDate(item_obj[key], false, true)"
                      :label="returnFilterKeyOrLabel(key, field)"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      hide-details="auto"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item_obj[key]"
                    @input="emitItemEditObj(key, $event)"
                    no-title
                    :locale="i18n.locale"
                    scrollable
                  >
                  </v-date-picker>
                </v-menu>

                <!-- MAP FIELDS -->
                <v-flex
                  v-else-if="['MAP'].includes(field.type)"
                  xs12
                  class="mb-3"
                >
                  <div class="navigation-drawer__item-title">{{ returnFilterKeyOrLabel(key, field) }}</div>
                  <div class="navigation-drawer__wrap">
                    <v-layout
                      v-if="field.editable"
                    >
                      <v-text-field
                        class="mr-4"
                        outlined
                        dense
                        :label="returnLabelFromColumn(field.longitude_key)"
                        v-model="item_obj[field.longitude_key]"
                        @input="emitItemEditObj(field.longitude_key, $event)"
                        hide-details="auto"
                      ></v-text-field>
                      <v-text-field
                        outlined
                        dense
                        :label="returnLabelFromColumn(field.latitude_key)"
                        v-model="item_obj[field.latitude_key]"
                        @input="emitItemEditObj(field.latitude_key, $event)"
                        hide-details="auto"
                      ></v-text-field>
                    </v-layout>

                    <CdMap
                      :mapObject="parseMapObject(JSON.stringify(
                        {
                          'longitude': item_obj[field.longitude_key],
                          'latitude': item_obj[field.latitude_key],
                        }
                      ))"
                    />
                  </div>
                </v-flex>

                <!-- MAP WITH MULTIPLE MARKERS FIELDS -->
                <v-flex
                  v-else-if="['MAP_MARKERS'].includes(field.type)"
                  xs12
                  class="mb-3"
                >
                  <div class="navigation-drawer__item-title">{{ returnFilterKeyOrLabel(key, field) }}</div>
                  <div class="navigation-drawer__wrap">
                    <CdMap
                      :mapArray="parseMapArray(item_obj[field.data])"
                      multiple_marker
                      :map_zoom="field?.map_zoom || 10"
                    />
                  </div>
                </v-flex>

                <!-- SLIDER FIELDS -->
                <v-flex
                  v-else-if="
                    ['SLIDER'].includes(field.type) &&
                    checkImagesNotEmpty(field)
                  "
                  xs12
                >
                  <div class="navigation-drawer__item-title">{{ returnFilterKeyOrLabel(key, field) }}</div>
                  <div class="navigation-drawer__wrap navigation-drawer__wrap--images">
                    <vue-scroll>
                      <div class="cd__image-slider">

                        <template
                          v-for="
                            (url, k) in field.img_fields
                          "
                        >
                          <template
                            v-if="item_obj[url]?.files"
                          >
                              <template v-for="(f_url, f_key) in item_obj[url].files">
                                <CdImageSliderItem
                                  :imageUrl="f_url.url"
                                  :key="k + '_' + f_key"
                                />
                              </template>
                          </template>
                          <template v-else>
                              <CdImageSliderItem
                                v-for="(imgUrl, f_idx) in parseFileUrls(item_obj[url])"
                                :key="k + '_' + f_idx"
                                :imageUrl="imgUrl"
                              />
                          </template>
                        </template>

                      </div>
                    </vue-scroll>
                  </div>
                </v-flex>

                <!-- CHART field -->
                <v-flex
                  v-else-if="['CHART'].includes(field.type)"
                  xs12
                >
                  <div class="navigation-drawer__item-title">{{ returnFilterKeyOrLabel(key, field) }}</div>
                  <div class="navigation-drawer__wrap">
                    <template
                      v-if="field.editable"
                    >
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-model="item_obj[key]"
                        @input="emitItemEditObj(key, $event)"
                        hide-details="auto"
                      ></v-text-field>
                    </template>
                    <CdChart :value="item_obj[key]" />
                  </div>
                </v-flex>

                <!-- ASSOCIATION SELECT FIELDS -->
                <template
                  v-else-if="['ASSOCIATION'].includes(field.type)"
                >
                  <v-select
                    v-if="field.editable"
                    outlined
                    dense
                    :value="getItemObjValueForAssociation(key)"
                    @input="setItemObjValueForAssociation(key, $event)"
                    :label="`${returnFilterKeyOrLabel(key, field)}`"
                    item-text="name"
                    item-value="id"
                    :items="custom_data_linked_tables_values[key]"
                    return-object
                    :readonly="!modal_create_mode && !canSave"
                    hide-details="auto"
                  />
                  <div v-else>
                    <span class="font-weight-bold mr-2">{{returnFilterKeyOrLabel(key, field)}}:</span>
                    <PrivacyFieldValue
                      v-if="isModalEntityPrivacyEnabled(field)"
                      :value="formatModalEntityDisplayValue(item_obj[key])"
                    />
                    <span v-else>{{ formatModalEntityDisplayValue(item_obj[key]) }}</span>
                  </div>
                </template>

                <!-- EXPANSION PANELS items -->
                <ExpansionPanelField
                  v-else-if="key === 'expansion-panels'"

                  :modal_create_mode="modal_create_mode"
                  :canSave="canSave"
                  :field="field"
                  :entity_fields="entity_fields"
                  :headers="headers"
                  :item_obj="item_obj"
                  @edit_obj="item_edit_obj[key] = $event"
                />
                <ExpansionPanelVariableField
                  v-else-if="key === 'expansion-panels-variable'"

                  :modal_create_mode="modal_create_mode"
                  :canSave="canSave"
                  :field="field"
                  :entity_fields="entity_fields"
                  :headers="headers"
                  :item_obj="item_obj"
                  @edit_obj="item_edit_obj[key] = $event"
                />

                <!-- create_association_row -->
                <template
                  v-else-if="['CREATE_ASSOCIATION_ROW'].includes(field.type)"
                >
                  <div>
                    <template v-if="item_obj[field.to]">
                      <v-alert
                        color="warning"
                        text
                        dense
                        class="ma-0 pa-0"
                      >
                        <div class="pa-3">
                          <span class="mr-2">{{field.label_if_result}}:</span>
                          {{
                            ('show_if_result' in field)
                              ? item_obj[field.show_if_result]
                              : item_obj[field.to]
                          }}
                        </div>

                        <div
                          v-if="
                            'additional_fields_result' in field
                            && field?.additional_fields_result?.length
                          "
                        >
                          <v-simple-table
                            dense
                            class="additional_fields_table">
                            <template v-slot:default>
                              <tbody>
                              <tr
                                v-for="(additional_item, additional_index) in field.additional_fields_result"
                                :key="additional_index"
                              >
                                <td class="text-caption">
                                  {{additional_item.label}}
                                </td>
                                <td class="text-caption">
                                  {{getValueCreateAssociationRow(field, additional_item.value)}}
                                </td>
                              </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                      </v-alert>

                    </template>
                    <template v-else>
                      <div v-if="checkAssociationPermission(field)">
                        <v-btn
                          :color="field.icon_color"
                          dark
                          elevation="0"
                          small
                          class="text-none"
                          :loading="create_association_row_loading"
                          @click="createFieldsFromAssociation(field)"
                        >{{field.label}}</v-btn>


                        <DynamicMainModalEntity
                          ref="modalCreateEntityForm"
                          v-model="create_association_row_dialog"
                          :canSave="canSave"
                          :modal_create_mode="true"
                          :multiple_entity="multiple_entity"

                          :custom_drawer_title="field.label"

                          :entity_fields="create_association_row_fields"
                          :item_obj="create_association_row_obj"

                          @save="saveAssociationRow(field)"
                        />
                      </div>
                    </template>
                  </div>
                </template>
                <!-- END create_association_row -->

              </v-layout>

            </template>

          </v-card-text>

          <v-footer>
            <v-layout justify-start>
              <v-btn
                class="mr-4"
                color="primary"
                elevation="0"
                @click="saveData()"
                small
                :disabled="
                  !form_valid ||
                  (
                    !modal_create_mode &&
                    !(canSave && Object.keys(item_edit_obj)?.length)
                  )
                "
              >
                <template v-if="modal_create_mode">{{i18n.t('common.create')}}</template>
                <template v-else>{{i18n.t('common.save')}}</template>

              </v-btn>
            </v-layout>
          </v-footer>

        </v-card>
      </v-form>

    </v-navigation-drawer>
  </div>

</template>

<script>
import Vue from "vue";
import axios from "axios";
import i18n from '@/lang/i18n';
import {mapGetters} from "vuex";
import CdMap from "@/modules/CustomData/views/customdata/NewComponents/CdMap.vue";
import CdImageSliderItem from "@/modules/CustomData/views/customdata/NewComponents/CdImageSliderItem.vue";
import { parseFileUrls } from "@/modules/CustomData/utils/image.js";
import {
	formatModalEntityDisplayValue,
	isModalEntityPrivacyEnabled,
} from '@/modules/CustomData/utils/modalEntityPrivacy.js';
import PrivacyFieldValue from '@/modules/CustomData/components/modalEntityFields/PrivacyFieldValue.vue';
import CdChart from "@/modules/CustomData/views/customdata/NewComponents/CdChart.vue";
import DynamicMainModalEntity from "@/modules/CustomData/components/DynamicMainModalEntity.vue";
import ExpansionPanelField from "@/modules/CustomData/components/fields/ExpansionPanelField.vue";
import ExpansionPanelVariableField from "@/modules/CustomData/components/fields/ExpansionPanelVariableField.vue";

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/uk';
import 'vue2-datepicker/locale/ru';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/de';

import TimeInput from "@/components/dynamic/TimeInput.vue";

export default {
  name: "DynamicModalEntity",
  components: {
    DynamicMainModalEntity,
    CdChart,
    CdImageSliderItem,
    CdMap,
    ExpansionPanelField,
    ExpansionPanelVariableField,
    PrivacyFieldValue,

    DatePicker,
    TimeInput,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    modal_create_mode: {
      type: Boolean,
      default: false,
    },
    canSave: {
      type: Boolean,
      default: false,
    },


    entity_fields: {
      type: Object,
      default: () => {},
    },

    headers: {
      type: Array,
      default: () => [],
    },
    item_obj: {
      type: Object,
      default: () => {},
    },

    multiple_entity: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    show: true,
    i18n,
    form_valid: true,

    bot_id: null,

    //Panel resize
    navigation: {
      width: localStorage.getItem("drawerModalWidth") || '50%',
      borderSize: 8
    },
    //Panel resize

    create_association_row_dialog: false,
    create_association_row_loading: false,
    create_association_row_obj: {
      id: null,
    },
    create_association_row_fields: {},

    //collect uniq key for editing
    item_edit_obj: {},

    timeError: '',
    timeValid: false,
    minTime: '13:00',
    maxTime: '18:00',
  }),

  mounted() {
    this.bot_id = this.$route?.params?.id

    //Panel resize
    this.setBorderWidth();
    this.setEvents();
    //Panel resize
  },

  beforeDestroy: function () {
    this.setEvents(true); // Pass true to remove EventListeners
  },

  computed: {
    ...mapGetters([
      'get_custom_data_front_json',
      'custom_data_linked_tables_values',
      'custom_data_linked_tables_full_data',
      'rules',
      'engine_settings',
      'custom_data_tables',
      'user',
    ]),

    modal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  methods: {
    isModalEntityPrivacyEnabled,
    formatModalEntityDisplayValue,

    //Panel resize
    setBorderWidth() {
      let i = this.$refs.drawerModal.$el.querySelector(
        ".v-navigation-drawer__border"
      );
      i.style.width = this.navigation.borderSize + "px";
      i.style.cursor = "ew-resize";
    },

    setEvents(clean = false) {
      const minSize = this.navigation.borderSize;
      const el = this.$refs.drawerModal.$el;
      const drawerBorder = el.querySelector(".v-navigation-drawer__border");
      const vm = this;
      const direction = el.classList.contains("v-navigation-drawer--right")
        ? "right"
        : "left";

      function resize(e) {
        document.body.style.cursor = "ew-resize";
        let f = direction === "right"
          ? window.innerWidth - e.clientX
          : e.clientX;
        el.style.width = f + "px";
      }

      if (clean) {
        drawerBorder.removeEventListener("mousedown", this.handleMouseDown, false);
        document.removeEventListener("mouseup", this.handleMouseUp, false);
      } else {
        drawerBorder.addEventListener(
          "mousedown",
          function(e) {
            if (e.offsetX < minSize) {
              el.style.transition ='initial';
              document.addEventListener("mousemove", resize, false);
            }
          },
          false
        );

        document.addEventListener(
          "mouseup",
          function() {
            el.style.transition ='';

            if(window.innerWidth < 960){
              vm.navigation.width = parseInt(window.innerWidth);
            } else {
              vm.navigation.width = el.style.width;
            }

            document.body.style.cursor = "";
            document.removeEventListener("mousemove", resize, false);

            localStorage.setItem("drawerModalWidth", vm.navigation.width);
          },
          false
        );
      }
    },
    //Panel resize end


    //fields
    returnFilterKeyOrLabel(key, item) {
      const label_from_column_name = this.entity_fields?.[item?.label_from_column_name]?.label

      return item?.label || label_from_column_name || key
    },
    returnLabelFromColumn(key, item = null) {
      let label = this.entity_fields[key]?.label || key
      let label_from_column_name = this.entity_fields?.[item?.label_from_column_name]?.label

      //get label from headers(columns in list)
      if(item?.label_from_column_name) {
        label_from_column_name =  this.headers?.find((i) => i.value === item.label_from_column_name )?.text
      }

      return item?.label || label_from_column_name || label
    },
    formatDate(isoTimeString, short = false, shortest = false) {
      if (!isoTimeString) return;
      const date = new Date(isoTimeString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      if (short) {
        return `${day}.${month}.${year.toString().slice(-2)} ${hours}:${minutes}`;
      } else if (shortest) {
        return `${day}.${month}.${year}`;
      } else {
        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
      }
    },
    //association field
    getItemObjValueForAssociation(key) {
      let item =  this.custom_data_linked_tables_values[key].filter((i) => {
        if (i.name === this.item_obj[key]){
          this.item_obj[key] = JSON.parse(JSON.stringify(i))
          return i
        } else if (i.name === this.item_obj[key]?.name) {
          return this.item_obj[key]
        }
      })

      return item[0]
    },
    setItemObjValueForAssociation(key, value) {
      if(value) {
        this.item_obj[key] = value
        this.item_edit_obj[key] = value
      } else {
        delete this.item_obj[key]
        delete this.item_edit_obj[key]
      }

    },


    // MAP
    parseMapObject(str) {
      try {
        if (str && str.trim() !== '') {
          return JSON.parse(str)
        } else {
          return { longitude: 0, latitude: 0 }
        }
      } catch (error) {
        console.error('Error parsing JSON:', error)
        return { longitude: 0, latitude: 0 }
      }
    },
    parseFileUrls,

    parseMapArray(str) {
      try {
        if (str && str.trim() !== '') {
          let arr = JSON.parse( str )

          if(arr?.length){
            arr = arr.reduce((acc, curr) => {
              if(curr?.lat && curr?.long) {
                acc.push({
                  position: {
                    lat: +curr.lat,
                    lng: +curr.long,
                  },
                  infoText: curr?.action || '',
                })
              }

              return acc
            }, [])
          }

          return arr
        } else {
          return []
        }
      } catch (error) {
        console.error('Error parsing JSON:', error)
        return []
      }
    },

    checkImagesNotEmpty(field) {
      if(!field?.img_fields?.length) return false

      let success = false

      for(const i in field?.img_fields) {
        const item = this.item_obj?.[field.img_fields[i]]

        if(item) {
          if(
            item?.files?.length
            && item.files.some((el) => el?.url)
          ){
            success = true
          } else {
            success = true
          }
        }
      }

      return success
    },

    async createFieldsFromAssociation(field) {
      this.create_association_row_loading = true

      this.create_association_row_fields = await JSON.parse(JSON.stringify(
        this.custom_data_tables.find(item => item.name === field.from)?.columns_json
      ))

      for(let i in this.create_association_row_fields) {
        if('association' in this.create_association_row_fields[i]) {
          await this.$store.dispatch('_customDataAxiosGetLinkedTablesValues', {
            modelName: this.create_association_row_fields[i].association.model_name,
            modelField: this.create_association_row_fields[i].association.model_field,
            linkedColumn: i,
            bot_id: this.bot_id,
            modelFieldLabel: this.create_association_row_fields[i].association?.model_field_label
          })
        }
      }

      this.create_association_row_loading = false
      this.create_association_row_dialog = true
    },

    //save row in association table
    async saveAssociationRow(field) {

      let request = this._.cloneDeep(this.create_association_row_obj);

      for(let i in request) {
        if (typeof request[i] === 'object') {
          request[i] = request[i]?.id || null
        }
      }

      const id = request?.id || null


      let success = false;
      const token = Vue.$cookies.get('token_e')
      const engine_url = this.engine_settings.active_url;
      const bot_id = this.bot_id;
      const model_field = field.from

      let url = `${engine_url}/kw/custom_modules/${model_field}/update/${id}/?bot_id=${bot_id}`
      if(id===null)
        url = `${engine_url}/kw/custom_modules/${model_field}/create/?bot_id=${bot_id}`

      await this.$store.dispatch('updateAjaxDialog', [true, true]);

      await axios
        .post(
          url,
          request,
          {
            headers: {
              'X-CSRF-TOKEN': token,
            },
          }
        )
        .then(
          async (response) => {
            await this.$store.dispatch('updateAjaxDialog', [false, false]);
            if (
              response.data &&
              response.data.data?.id &&
              response.data.status &&
              response.data.status === 'success'
            ) {
              const data = {
                id: this.item_obj.id,
                [field.to]: response.data.data.id,
              }

              await this.$root.$emit('CustomDataTab', data)
              success = true;
            }
          },
          (err) => {
            if (
              err &&
              err.response &&
              err.response.data &&
              err.response.data.message_alias
            ) {
              let message_alias = err.response.data.message_alias;

              if (message_alias === 'access_error') {
                this.$store.dispatch('updateAjaxDialogError', [
                  err,
                  this.$t('common.error'),
                  this.$t('common.error_permitions'),
                ]);
              } else {
                this.$store.dispatch('updateAjaxDialogError', [
                  err,
                  this.$t('common.error'),
                  this.$t('common.error_save'),
                ]);
              }
            } else {
              this.$store.dispatch('updateAjaxDialogError', [
                err,
                this.$t('common.error'),
                this.$t('common.error_save'),
              ]);
            }
          }
        ).finally(() => {
          this.create_association_row_dialog = true
          this.$emit('input', false);
        });

      return success;
    },

    checkAssociationPermission(field) {
      let access = true

      if(field?.save_by_permission) {
        access =
          this.user.role.permissions
            .custom_data?.models?.[this.bot_id]?.[field?.from]?.canAdd

        //permission for Root Admin
        if(this.user?.root === 1) access = true
      }

      return access
    },

    checkKeyNotExists(key, field) {
      let show = true

      if(
        field?.hide_key_not_exists
        && !(key in this.item_obj)
      ) show = false

      return show
    },

    checkSomeKeyNotExists(f) {
      let show = true

      if(f?.hide_some_key_not_exists) {
        const items = Object.keys(f.items).filter((i) => {
          if(this.checkKeyNotExists(i, f.items[i])) {
            return i
          }
        })

        if(!items?.length) show = false
      }

      return show
    },

    getValueCreateAssociationRow(field, key) {
      const table = this.custom_data_linked_tables_full_data?.[field?.to]
      let item = null

      if(table && key) {
        item = table.find((i) => i.id === this.item_obj?.[field?.to])

        if(item) {
          return item[key]
        }
      }

      return ''
    },

    // edit for Date and Time
    checkDateValidations(date, field) {
      let disabled = false

      if(
        field?.validate?.rules?.type === 'date'
        && !field?.validate?.rules?.ignore_in_table
      ) {
        const timeString = this.item_obj?.[field?.validate?.rules?.val_from_field];
        const now = timeString ? new Date(timeString) : new Date();
        const d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0 , 0);
        const timestamp = d.getTime();
        const compare = this.$getComparator(field?.validate?.rules?.action)

        if(compare(date.getTime(), timestamp) ) disabled = true
      }

      return disabled
    },
    checkTimeValidations(date, field) {
      let disabled = false

      if(
        field?.validate?.rules?.type === 'time'
        && field?.validate?.rules?.action
        && !field?.validate?.rules?.ignore_in_table
      ) {
        let hours = 0, minutes = 0;
        const now = new Date();
        let timeString = this.item_obj?.[field?.validate?.rules?.val_from_field];

        if(timeString) {
          //fix if chosen date is not Today
          if(
            this.entity_fields?.[field?.validate?.rules?.val_from_field]
              ?.validate?.rules?.type === 'date'
          ) {
            if(this.isToday(timeString)) {
              timeString = `${now.getHours()}:${now.getMinutes()}`
            } else {
              timeString = '00:00'
            }
          }

          [hours, minutes] = timeString.split(':').map(Number);
        } else if(!field?.validate?.rules?.val_from_field) {
          hours = now.getHours();
          minutes = now.getMinutes();
        }

        const d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);
        const timestamp = d.getTime();
        const compare = this.$getComparator(field?.validate?.rules?.action)

        if(compare( timestamp, date.getTime() )) disabled = true
      }

      return disabled
    },
    checkClearableValidations(field) {
      let clearable = true

      if(field?.validate?.disable_clearable) {
        const required_field = field?.validate?.disable_clearable?.required_field

        if(
          required_field
          && this.item_obj?.[required_field]
        ) clearable = false
      }

      return clearable

    },
    //based on disable_clearable
    checkDisableValidations(field, key) {
      let disabled = false

      if(field?.validate?.required_field_empty) {
        //val from another field
        const val = this.item_obj[field?.validate?.required_field_empty]
        if(!val) disabled = true
      }
      if(field?.validate?.required_field_not_empty) {
        //val from another field
        const val = this.item_obj[field?.validate?.required_field_not_empty]
        if(val) disabled = true
      }

      if(
        field?.validate?.disabled_in_table_on_edit === true
        && this.item_obj[key]
      ) disabled = true

      return disabled
    },
    isToday(dateString) {
      const [day, month, year] = dateString.split('.').map(Number);
      const givenDate = new Date(year, month - 1, day);

      const today = new Date();
      return givenDate.getDate() === today.getDate() &&
        givenDate.getMonth() === today.getMonth() &&
        givenDate.getFullYear() === today.getFullYear();
    },

    emitItemEditObj(key, val) {
      this.item_edit_obj[key] = val
    },

    saveData() {
      const request = {
        ...this.item_edit_obj,
        id: this.item_obj.id,
      }

      if(this.item_obj.hasOwnProperty('kw_user_id')) {
        request['kw_user_id'] = this.item_obj.kw_user_id
      }

      this.$emit('save', request)
    },

    validateTime(key) {
      this.timeError = '';
      this.timeValid = false;

      // Проверяем полноту ввода
      if (this.item_obj[key].length < 5) return;

      const [hours, minutes] = this.item_obj[key].split(':').map(Number);

      // Проверка формата времени
      if (isNaN(hours) || isNaN(minutes) || hours > 23 || minutes > 59) {
        this.timeError = 'Некорректное время';
        return;
      }

      // Преобразуем в минуты для сравнения диапазона
      const inputMinutes = hours * 60 + minutes;
      const [minHours, minMinutes] = this.minTime.split(':').map(Number);
      const [maxHours, maxMinutes] = this.maxTime.split(':').map(Number);

      const minTimeMinutes = minHours * 60 + minMinutes;
      const maxTimeMinutes = maxHours * 60 + maxMinutes;

      // Проверка диапазона
      if (inputMinutes < minTimeMinutes || inputMinutes > maxTimeMinutes) {
        this.timeError = `Время должно быть между ${this.minTime} и ${this.maxTime}`;
      } else {
        this.timeValid = true;
        this.$emit('time-validated', {
          valid: true,
          hours,
          minutes,
          timeString: this.timeInput
        });
      }
    },
  },

  watch: {
    value: function(val) {
      if(val) {
        //reset editing keys
        this.item_edit_obj = {}
      }

      if(!val && this.create_association_row_dialog) {
        this.create_association_row_dialog = false
      }
    }
  },
}

</script>

<style lang="scss" scoped>
.settings-form::v-deep {
  height: 100%;

  .v-card {
    height: 100%;
    display: flex;
    flex-direction: column;

    .v-card__text{
      padding-top: 5px;
      flex-grow: 1;
      overflow: auto;
    }
  }
}

.modal__close-btn {
  z-index: 1;
  top: 9px;
}

.modal__menu-btn {
  z-index: 1;
  top: 48px;

  &::before {
    opacity: 0.08;
  }
}


.v-navigation-drawer {
  &::v-deep .v-navigation-drawer__border {
    border-right: 1px solid rgba(0, 0, 0, 0.05);
    background-color: rgba(0, 0, 0, 0.08) !important;

    &:after {
      content: '·······';
      color: #000;
      transform: rotate(90deg);
      position: absolute;
      top: 50%;
      left: -14px;
      font-size: 24px;
      line-height: 0.3;
      pointer-events: none;
    }

    @media screen and (max-width: 959px){
      display: none;
    }
  }
}
.navigation-drawer {
  &__title {
    font-size: 18px;
    margin-top: 30px;
    padding-left: 27px;
    padding-right: 50px;
    padding-bottom: 10px;
    text-align: left;
  }

  &__wrap {
    padding: 20px 15px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.38);
    margin-bottom: 25px;

    @media (min-width: 960px) {
      &--images::v-deep .__rail-is-horizontal {
        display: none;
      }
    }

    .cd__image-slider {
      display: flex !important;
      gap: 16px !important;
      height: 400px !important;
    }
  }

  &__item-title {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 5px;
    text-align: left;
  }
}

.additional_fields_table {
  &::v-deep {
    .v-data-table__wrapper {
      max-width: 100%;
      overflow-x: hidden !important;

      td {
        padding: 0 6px;
        word-break: break-word;
        max-width: inherit;
      }
    }
  }
}

</style>